export enum UserStatusType {
  Online = 'online',
  Away = 'away',
  Busy = 'busy',
  Offline = 'offline'
}
